import { render, staticRenderFns } from "./QuoteRow.vue?vue&type=template&id=145b2d32&scoped=true&"
import script from "./QuoteRow.vue?vue&type=script&lang=js&"
export * from "./QuoteRow.vue?vue&type=script&lang=js&"
import style0 from "./QuoteRow.vue?vue&type=style&index=0&id=145b2d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145b2d32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
